import { AttachmentType } from "../../../../../CoStar/Api/Search/Result/Summary/index.js";
/** CoStar.Api.AptsSearch.Result.Summary.AttachmentType */
export { AttachmentType };
